const g2 = require('../g2');
const CommonUtil = require('../utils/CommonUtil');
/**
 * @class
 * @classdesc
 * 定义用于在网络中传输GIS标绘的数据结构
 * @alias G.plot.PlotSchema
 * @param {Object} [options]
 * @param {String} [options.id] 唯一标识
 * @param {String} [options.name] 名称
 * @param {String} [options.userId] 标绘用户ID
 * @returns {G.plot.PlotSchema} 返回用于在网络中传输GIS标绘的数据结构
 */
var schema = function(opts) {
    this.$type = 'PlotSchema,http://www.Gs.com';
    var otpss = opts || {};
    //唯一标识
    this.id = otpss.id;
    //名称
    this.name = otpss.name;
    //标绘用户ID
    this.userId = otpss.userId;
    //标绘创建时间
    this.createTime = null;
    //标绘元素数组
    this.elements = [];
    // 视野范围
    this.extent = null;
}

/**
 * 添加一个标绘元素
 * @param {g2.ele.Element} element 标绘元素
 */
schema.prototype.addElement = function(element) {
    this.elements.push(element);
}

/**
 * 获取标绘元数个数
 * @returns {Number} 返回个数
 */
schema.prototype.getCount = function() {
    return this.elements.length;
}

/**
 * 获取指定索引位置的标绘元素
 * @param {Number} index 索引
 * @returns {g2.ele.Element} 返回标绘元素
 */
schema.prototype.getElement = function(index) {
    return this.elements[index];
}

//static
/**
 * 根据序列化后的JSON创建JS示例
 * @method
 * @memberOf G.plot.PlotSchema
 * @param schemaJson {String|Object}
 */
schema.fromJson = function(schemaJson) {
    let schemaObj;
    if (CommonUtil.isString(schemaJson)) {
        schemaObj = JSON.parse(schemaJson);
    } else {
        schemaObj = schemaJson;
    }
    //修改标绘方案适配EGIS
    let instance = new schema({
        id: schemaObj.id,
        name: schemaObj.name,
        userId: schemaObj.userId
    });
    if (schemaObj.extent) {
        let extent = new g2.sfs.Envelope({
            minx: schemaObj.extent.minx,
            maxx: schemaObj.extent.maxx,
            miny: schemaObj.extent.miny,
            maxy: schemaObj.extent.maxy,
        });
        instance.extent = extent;
    }
    if (schemaObj.camera) {
        let camera = {
            heading: schemaObj.camera.heading,
            pitch: schemaObj.camera.pitch,
            roll: schemaObj.camera.roll,
            position: new g2.sfs.Point({
                x: schemaObj.camera.position.x,
                y: schemaObj.camera.position.y,
                z: schemaObj.camera.position.z,
                spatialReference: schemaObj.camera.position.spatialReference,
            })
        };
        instance.camera = camera;
    }
    let deserializer = new g2.core.Deserializer();
    //elements
    for (let i = 0; i < schemaObj.elements.length; i++) {
        let element = deserializer.createJsInstance(schemaObj.elements[i]);
        instance.addElement(element);
    }
    return instance;
}
module.exports = schema;